export const getDateIntervalColumnFieldKey = (startDate: string, endDate: string) => {
  return `[${startDate};${endDate}]`
}
